import { createFileRoute } from '@tanstack/react-router'

import { CampaignDetail } from '@/features/marketing/components/campaign-detail'
import { requireFlow } from '@/features/auth/guards'

export const Route = createFileRoute('/_authenticated/marketing/$campaignId')({
  beforeLoad: requireFlow('marketing'),
  component: CampaignDetailPage,
})

function CampaignDetailPage() {
  const { campaignId } = Route.useParams()
  return <CampaignDetail campaignId={campaignId} />
}
